export class ApplicationValueDto {
    fixturesValue: number;
    improveValue: number;
    landValue: number;
    mineralValue: number;
    personalValue: number;
    treesValue: number;
    totalValue: number;
    exemptValue: number;
    netValue: number;
    penaltyValue: number;
    public create() {
        return {
            fixturesValue: null,
            improveValue: null,
            landValue: null,
            mineralValue: null,
            personalValue: null,
            treesValue: null,
            totalValue: null,
            exemptValue: null,
            netValue: null,
            penaltyValue: null,
        }
    }
}
